import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../services/API";

const mergeUniqueVideos = (existing = [], incoming = []) => {
    const seen = new Set(existing.map((item) => item.id));
    const merged = [...existing];

    incoming.forEach((item) => {
        if (item && !seen.has(item.id)) {
            merged.push(item);
            seen.add(item.id);
        }
    });

    return merged;
};

export const getHomePageVideo = createAsyncThunk("getHomePageVideo", async (value) => {
    try {
        // const response = await axiosInstance.get(`/post/recomm_post/?page=${value}`);
        const response = await axiosInstance.get(`/recomm/feed/?page=${value}`);
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const getVideoById = createAsyncThunk("getVideoById", async (id) => {
    try {
        const response = await axiosInstance.get(`/post/details/${id}/`);
        const result = response.data;
        return result;
    } catch (error) {
        return error.response.data;
    }
});

export const friendsFeeds = createAsyncThunk("friendsFeeds", async (value) => {
    // const response = await axiosInstance.get(`/post/friends_feeds/?page=${value}`);
    const response = await axiosInstance.get(`/post/mutual-friends-feeds/?page=${value}`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const localFeeds = createAsyncThunk("localFeeds", async (value, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get(`/post/county-video-recommendation/?page=${value}`);
        const result = response.data;
        return result;
    } catch (error) {
        // Return the error response data for 400 errors
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ detail: "Something went wrong" });
    }
});

export const getVideoShared = createAsyncThunk("getVideoShared", async (postId) => {
    const response = await axiosInstance.get(`/post/view_shared_post/${postId}/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const HomepageVideoLike = createAsyncThunk("HomepageVideoLike", async (key) => {
    const response = await axiosInstance.post(`/post/like/${key}/`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

// Save Video by Id
export const SavedVideosById = createAsyncThunk(
    "SavedVideosById",
    async (id) => {
        const response = await axiosInstance.post(`/post/toggle_save_post/${id}/`);
        try {
            const result = response.data;
            return { result, id };
        } catch (error) {
            return error;
        }
    },
);
export const watchVideos = createAsyncThunk("selectVideo", async (data) => {
    try {
        const response = data;
        return response;
    } catch (error) {
        return error;
    }
});

export const getWithoutLoginVideos = createAsyncThunk("getWithoutLoginVideos", async (value) => {
    const response = await axiosInstance.get(`/post/public-preview/posts/?page=${value}`);
    try {
        const result = response.data;
        return result;
    } catch (error) {
        return error;
    }
});

export const postNotInterested = createAsyncThunk(
    "postNotInterested",
    async (postId, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/post/${postId}/not-interested/`);
            return response.data;
        } catch (error) {
            if (error.response?.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ detail: "Failed to mark as not interested" });
        }
    }
);

// Track how much of a video a user watched before leaving it
export const trackWatchVideo = createAsyncThunk(
    "trackWatchVideo",
    async ({ postId, data }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.post(`/post/track-watch/${postId}/`, data);
            return response.data;
        } catch (error) {
            if (error?.response?.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue({ detail: "Failed to track watch event" });
        }
    }
);

export const HomepageVideoSlice = createSlice({
    name: "HomepageVideo",
    initialState: {
        AllPosts: [],
        videoData: [],
        homePageVideos: [],
        postCommants: [],
        currentIndex: 0,
        pageNumber: 1,
        next: null,
        loading: false,
        initialLoading: false,
        error: null,
    },
    reducers: {
        // HomepageVideo action reducers
        setClearHomepageVideos: (state) => {
            state.homePageVideos = [];
            // state.videoData = {};
            state.postCommants = [];
            state.currentIndex = 0;
            state.pageNumber = 1;
            state.next = null;
            state.loading = false;
            state.error = null;
        },

        setCurrentIndexfn: (state, action) => {
            state.currentIndex = action.payload;
        },
        setPageNumber: (state, action) => {
            state.pageNumber = action.payload;
        },
        setVideoLike: (state, action) => {
            const postId = action.payload;

            const videoIndex = state.homePageVideos?.findIndex((item) => item.id === postId);

            if (videoIndex !== -1) {
                const updatedVideo = {
                    ...state.homePageVideos[videoIndex],
                    likes_count: state.homePageVideos[videoIndex].likes_count + 1,
                    userliked: true,
                }


                state.homePageVideos[videoIndex] = updatedVideo
            }

            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));

            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        likes_count: stateVideoData[videoIndex2]?.likes_count + 1,
                        userliked: true,
                    };
                }
            }
        },
        removeVideoLike: (state, action) => {
            const postId = action.payload;

            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);

            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    likes_count: state.homePageVideos[videoIndex].likes_count - 1,
                    userliked: false,
                };
            }
            // Only update videoData if it's an array
            if (Array.isArray(state.videoData)) {
                const videoIndex2 = state.videoData?.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        likes_count: state.videoData[videoIndex2]?.likes_count - 1,
                        userliked: false,
                    };
                }
            }

        },

        reshareVideo: (state, action) => {
            const postId = action.payload;
            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);
            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    userreshared: true,
                }
            }
            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));
            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        userreshared: true,
                    };
                }
            }
        },
        reshareRemove: (state, action) => {
            const postId = action.payload;
            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);
            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    userreshared: false,
                }
            }
            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));
            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        userreshared: false,
                    };
                }
            }
        },

        commentCountIncrease: (state, action) => {
            const postId = action.payload.postId;
            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);
            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    comment_thread_count: state.homePageVideos[videoIndex].comment_thread_count + 1,
                }
            }
            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));
            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        comment_thread_count: stateVideoData[videoIndex2]?.comment_thread_count + 1,
                    };
                }
            }
        },
        commentCountDecrease: (state, action) => {
            const postId = action.payload.postId;
            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);
            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    comment_thread_count: state.homePageVideos[videoIndex].comment_thread_count - 1,
                }
            }
            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));
            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        comment_thread_count: stateVideoData[videoIndex2]?.comment_thread_count - 1,
                    };
                }
            }
        },
        followUser: (state, action) => {
            const userId = action.payload.id;
            if (Array.isArray(state.homePageVideos)) {
                state.homePageVideos = state.homePageVideos.map((item) =>
                    item.created_by.id === userId
                        ? { ...item, userfollowing: !item.userfollowing }
                        : item
                );
            }
        },
        removeNotInterestedPost: (state, action) => {
            const postId = action.payload;
            state.homePageVideos = state.homePageVideos.filter((item) => item.id !== postId);
            if (Array.isArray(state.videoData)) {
                state.videoData = state.videoData.filter((item) => item.id !== postId);
            }
        },
    },
    extraReducers: (builder) => {
        //watchVideos action promises
        builder.addCase(watchVideos.pending, (state) => {
            state.loading = true;
            state.videoData = [];

        });
        builder.addCase(watchVideos.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.loading = false;
        });
        builder.addCase(watchVideos.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // HomepageVideo action promises
        builder.addCase(getHomePageVideo.pending, (state, action) => {
            state.loading = true;
            state.videoData = [];

            // if (state.pageNumber === 1) {
            //     state.homePageVideos = [];
            // }
        });
        builder.addCase(getHomePageVideo.fulfilled, (state, action) => {
            state.videoData = action.payload;
            // state.homePageVideos = mergeUniqueVideos(state.homePageVideos, action.payload?.result?.post ?? []);
            state.homePageVideos = mergeUniqueVideos(state.homePageVideos, action.payload?.post ?? []);
            state.loading = false;
            // if (action.payload.value === 1) {
            state.initialLoading = false;
            // }
        });

        builder.addCase(getHomePageVideo.rejected, (state, action) => {
            state.loading = false;
            state.initialLoading = false;
            state.error = action.payload;
        });

        //getsinglePost action promises
        builder.addCase(getVideoById.pending, (state) => {
            state.loading = true;
            state.initialLoading = true;
        });
        builder.addCase(getVideoById.fulfilled, (state, action) => {
            state.homePageVideos = [action.payload, ...Array.isArray(state.homePageVideos) ? state.homePageVideos : []];
            state.loading = false;
            state.initialLoading = false;
        });
        builder.addCase(getVideoById.rejected, (state, action) => {
            state.loading = false;
            state.initialLoading = false;
            state.error = action.payload;
        });

        ///public videos without login
        builder.addCase(getWithoutLoginVideos.pending, (state) => {
            state.loading = true;
            state.initialLoading = true;
            if (state.pageNumber === 1) {
                state.homePageVideos = [];
            }
        });
        builder.addCase(getWithoutLoginVideos.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.homePageVideos = mergeUniqueVideos(state.homePageVideos, action.payload?.post ?? []);
            state.loading = false;
            state.initialLoading = false;
        });
        builder.addCase(getWithoutLoginVideos.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.initialLoading = false;
        });

        /* friendsFeeds action promises */
        builder.addCase(friendsFeeds.pending, (state) => {
            state.loading = true;
            state.videoData = {};
            if (state.pageNumber === 1) {
                state.homePageVideos = [];
            }
        });
        builder.addCase(friendsFeeds.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.next = action.payload.next;
            state.homePageVideos = mergeUniqueVideos(state.homePageVideos, action.payload?.results?.post ?? []);
            state.loading = false;
        });

        builder.addCase(friendsFeeds.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        // save video
        builder.addCase(SavedVideosById.pending, (state) => {
            state.loading = true;
        });

        builder.addCase(SavedVideosById.fulfilled, (state, action) => {
            const postId = action.payload.id;
            const videoIndex = state.homePageVideos.findIndex((item) => item.id === postId);
            if (videoIndex !== -1) {
                state.homePageVideos[videoIndex] = {
                    ...state.homePageVideos[videoIndex],
                    usersaved: state.homePageVideos[videoIndex].usersaved ? false : true,
                }
            }
            const stateVideoData = JSON.parse(JSON.stringify(state.videoData));
            if (Array.isArray(stateVideoData)) {
                const videoIndex2 = stateVideoData.findIndex((item) => item.id === postId);
                if (videoIndex2 !== -1) {
                    state.videoData[videoIndex2] = {
                        ...state.videoData[videoIndex2],
                        usersaved: stateVideoData[videoIndex2]?.usersaved ? false : true,
                    };
                }
            }
            state.loading = false;
        });
        builder.addCase(SavedVideosById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        /* localFeeds action promises */
        builder.addCase(localFeeds.pending, (state) => {
            state.loading = true;
            state.videoData = {};
            if (state.pageNumber === 1) {
                state.homePageVideos = [];
            }
        });
        builder.addCase(localFeeds.fulfilled, (state, action) => {
            state.videoData = action.payload;
            state.next = action.payload.next;
            state.homePageVideos = mergeUniqueVideos(state.homePageVideos, action.payload?.posts ?? []);
            state.loading = false;
        });
        builder.addCase(localFeeds.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { setCurrentIndexfn, setPageNumber, setVideoLike, removeVideoLike, commentCountIncrease, commentCountDecrease, followUser, setClearHomepageVideos, reshareRemove, reshareVideo, removeNotInterestedPost } = HomepageVideoSlice.actions;
export default HomepageVideoSlice.reducer;
